import { MutationTree } from 'vuex';
import { ReportsState, ReportsAction } from './types';
import { Models } from '@mtap-smartcity/api';

export const mutations: MutationTree<ReportsState> = {
  [`${ReportsAction.FetchReportsStatus}Handler`]: (state, reportsStatus: ReportsState['reportsStatus']) => {
    state.reportsStatus = reportsStatus;
  },

  ADD_CONFIG: (state, newConfig: Models.Reports.Config) => {
    if (state.reportsStatus) {
      state.reportsStatus.configs.push(newConfig);
    }
  },

  [`${ReportsAction.DeleteReportConfig}Handler`]: (state, uuid: string) => {
    if (state.reportsStatus) {
      state.reportsStatus.configs = state.reportsStatus.configs.filter((config) => config.uuid !== uuid);
      // Also remove associated reports
      state.reportsStatus.reports = state.reportsStatus.reports.filter((report) => report.config_uuid !== uuid);
    }
  },

  ADD_REPORTS(state: ReportsState, newReports: Models.Reports.Report[]) {
    if (state.reportsStatus) {
      // Add new reports, avoiding duplicates by ID
      const existingIds = new Set(state.reportsStatus.reports.map((r) => r.id));
      const uniqueNewReports = newReports.filter((r) => !existingIds.has(r.id));

      state.reportsStatus.reports.push(...uniqueNewReports);
    }
  },
};
